'use strict';

angular.module('vendor').directive('catalogViewStatusListing', function($rootScope) {
  return {
    restrict: 'E',
    templateUrl: require('./catalog-view-status-listing.directive.html'),
    css: [require('../catalog-dashboard/catalog-dashboard.useable.css')]
  }
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/catalog/views/catalog-view-status-listing.directive.js
// module id = 930
// module chunks = 0